/**
 * .js-filter（チェックボックス/ラジオ）の複数選択で.js-filter-itemに.X-hitクラスを着脱
 * 1：data-filter-groupが一致する.js-filter-itemを補足（"all"の場合は全件）
 * 2：data-filter-typeのXを読み取り、.js-filter-itemの子要素のdata-filter-Xをチェック
 * 3：チェック中のいずれかのdata-filter-valと一致すれば.X-hitを付与、1つも一致しなければ .X-hitを除去（OR検索）
 */
function applyFilter() {
  const filterInputs = document.querySelectorAll('.js-filter')
  if (!filterInputs.length) return

  const checkedByGroup = {}
  const activeTypes = new Set()
  filterInputs.forEach((input) => {
    if (!input.checked) return
    const group = input.dataset.filterGroup
    const type = input.dataset.filterType
    const val = input.dataset.filterVal
    if (!group || !type || val === undefined) return
    activeTypes.add(type)
    if (!checkedByGroup[group]) checkedByGroup[group] = {}
    if (!checkedByGroup[group][type]) checkedByGroup[group][type] = []
    checkedByGroup[group][type].push(val)
  })

  const filterAreas = document.querySelectorAll('.js-filter-area')
  const filterTypes = [
    ...new Set(
      Array.from(filterInputs)
        .map((i) => i.dataset.filterType)
        .filter(Boolean)
    ),
  ]
  filterAreas.forEach((area) => {
    area.classList.toggle('is-filtering', activeTypes.size > 0)
    filterTypes.forEach((t) => {
      area.classList.toggle(`is-filtering-${t}`, activeTypes.has(t))
    })
  })

  Object.entries(checkedByGroup).forEach(([group, types]) => {
    Object.entries(types).forEach(([type, vals]) => {
      const hitClass = `${type}-hit`
      const attrName = `data-filter-${type}`
      const filterItems =
        group === 'all'
          ? document.querySelectorAll('.js-filter-item')
          : document.querySelectorAll(`.js-filter-item[data-filter-group="${group}"]`)
      const valsStr = vals.map((v) => String(v))

      filterItems.forEach((item) => {
        const children = item.querySelectorAll(`[${attrName}]`)
        let hasMatch = false

        children.forEach((child) => {
          const childVal = child.getAttribute(attrName)
          if (childVal == null || childVal === '') return
          const childVals = childVal.split(',').map((v) => String(v).trim())
          if (childVals.some((cv) => valsStr.includes(cv))) {
            hasMatch = true
          }
        })

        if (hasMatch) {
          item.classList.add(hitClass)
        } else {
          item.classList.remove(hitClass)
        }
      })
    })
  })

  // ini: いずれもチェックされていない場合はすべてにini-hitを付与（全表示）
  if (!activeTypes.has('ini')) {
    document.querySelectorAll('.js-filter-item').forEach((item) => {
      item.classList.add('ini-hit')
    })
  }

  // markMapは常にini-hitを付与
  document.querySelectorAll('.markMap__block').forEach((item) => {
    item.classList.add('ini-hit')
  })

  if (activeTypes.size === 0) {
    document.querySelectorAll('.js-filter-item').forEach((item) => {
      filterTypes.forEach((t) => {
        if (t) item.classList.remove(`${t}-hit`)
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('change', (e) => {
    if (!e.target.closest('.js-filter')) return
    applyFilter()
  })
  document.addEventListener('reset', (e) => {
    if (e.target.closest('.js-filter-wrap')) {
      setTimeout(applyFilter, 0)
    }
  })
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.pageNav__item[data-filter-day]')
    if (!link) return
    const dayVal = link.getAttribute('data-filter-day')
    if (!dayVal) return
    const dayRadio = document.querySelector(`.js-filter[data-filter-type="day"][data-filter-val="${dayVal}"]`)
    if (dayRadio && !dayRadio.checked) {
      dayRadio.checked = true
      applyFilter()
    }
  })
  applyFilter()
  setTimeout(applyFilter, 100)
})
